import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';

export default function UnauthorizedPage() {
  const { user, logout } = useAuth();
  const { t } = useI18n();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-4 text-center">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-6">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {t('team_unauth_title')}
          </h1>

          <p className="text-gray-600 mb-6">
            {t('team_unauth_text')}
          </p>

          {user && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-500">
                {t('team_unauth_signedInAs')} <span className="font-medium text-gray-700">{user.email}</span>
              </p>
              <p className="text-sm text-gray-500">
                {t('team_unauth_role')} <span className="font-medium text-gray-700 capitalize">{user.platformRole === 'super_admin'
                  ? t('pg_role_admin')
                  : (user.memberships?.find(m => m.orgId === user.currentOrgId)?.role ?? user.platformRole ?? '').replace('_', ' ')}</span>
              </p>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
              {t('team_unauth_home')}
            </Link>
            <button
              onClick={logout}
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              {t('team_unauth_logout')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
